import {
//	BrowserRouter as Router,
//	Switch,
//	Route,
//	Link,
	useRouteMatch,
	useParams,
	useLocation,
	useHistory
} from "react-router-dom";
import React, { useRef, useState, useEffect, createRef } from "react";

import * as common from "./common";

import TopNav from "./TopNav";

import {
	Breadcrumb,
	Button,
	Container
} from "react-bootstrap";


// Component ===================================================================

function LinkListAddComplete ()
{
	const routeMatch = useRouteMatch();
	const location = useLocation();
	const params = useParams();
	const history = useHistory();

	//console.log( "LinkListAddComplete > LinkListAddComplete () routeMatch : " + JSON.stringify( routeMatch ) );
	//console.log( "LinkListAddComplete > LinkListAddComplete () location : " + JSON.stringify( location ) );
	//console.log( "LinkListAddComplete > LinkListAddComplete () params : " + JSON.stringify( params ) );

	// 遅延実行処理
	// ※ 非同期処理(awaitの記述不要)はここで実行すること … ここで実行しないと何度も実行されてしまう
	useEffect( function ()
	{
		// ページタイトル設定
		document.title = common.PAGE_TITLE + " [リンクリスト(新規追加完了)]";
	}, [] );

	return (
		<>

			{/* ヘッダー部 */}
			<div className="right_header bg-light">

				<Breadcrumb className="breadcrumb_list">
					<Breadcrumb.Item onClick={ () => history.push( "/component/LinkList" ) }>リンクリスト</Breadcrumb.Item>
					<Breadcrumb.Item active>新規作成 (完了)</Breadcrumb.Item>
				</Breadcrumb>

				<TopNav />

			</div>

			{/* メイン部 */}
			<Container fluid className="main_container">

				<h4 className="mb-4">
					リンク新規作成 (完了)
				</h4>

				<div className="mt-5">
					<span className="material-icons success_icon">check_circle_outline</span>
				</div>

				<p className="text-center">
					リンクを保存しました。
				</p>

				<div className="mt-5 mb-2 d-flex justify-content-center action_btn_group">
					<Button variant="secondary" onClick={ () => history.push( "/component/LinkList" ) }>リンクリスト一覧</Button>
				</div>

			</Container>

		</>
	);
}

export default LinkListAddComplete;
